<template>
  <v-layout>
    <v-dialog v-model="dialog_ativo" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-btn color="#000" class="mr-3" icon @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="headline">Pedido Compra RMS</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0 px-2 mt-6">
          <v-container class="pb-0">
            <v-row>
              <v-col cols="12" class="pt-1 pb-0">
                <v-text-field
                  outlined
                  v-model="editedItem.fornecedor"
                  label="Código Fornecedor*"
                  style="margin-left: 5px"
                  maxlength="7"
                  counter="7"
                  @input="$v.editedItem.fornecedor.$touch()"
                  @blur="$v.editedItem.fornecedor.$touch()"
                  :error-messages="fornecedorErrors"
                  @keyup="editedItem.fornecedor = `${$event.target.value}`.replace(/[a-zA-Zç,~;.]/g, '')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="pt-1 pb-0">
                <v-text-field
                  outlined
                  v-model="editedItem.forma_de_pagamento"
                  label="Forma de Pagamento*"
                  style="margin-left: 5px"
                  maxlength="3"
                  counter="3"
                  @input="$v.editedItem.forma_de_pagamento.$touch()"
                  @blur="$v.editedItem.forma_de_pagamento.$touch()"
                  :error-messages="codComprasErrors"
                  @keyup="editedItem.forma_de_pagamento = `${$event.target.value}`.replace(/[a-zA-Zç,~;.]/g, '')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="pa-0 pl-5">
                <p class="mb-10">{{ infoPagamento }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="fechar">Fechar</v-btn>
          <v-btn text @click="executarRelatorio()">Gerar Relatório</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import $axios from './../../../api/api.js'

export default {
  model:  {
    prop: "valor_modelo",
    event: "atualizacao:valor_modelo"
  },
  props: ["valor_modelo", "pedidoSelecionado"],
  data: () => ({
    editedItem: {
      fornecedor: "",
      forma_de_pagamento: ""
    }
  }),
  validations: {
    editedItem: {
      fornecedor: {
        required,
        maxLength: maxLength(7)
      },
      forma_de_pagamento: {
        required,
        maxLength: maxLength(3)
      }
    },
  },
  computed: {
    dialog_ativo: {
      get: function () {
        return this.valor_modelo;
      },
      set: function (novo_valor) {
        return this.$emit("atualizacao:valor_modelo", novo_valor);
      }
    },
    fornecedorErrors() {
      const errors = [];
      if (!this.$v.editedItem.fornecedor.$dirty) return errors;
      !this.$v.editedItem.fornecedor.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.fornecedor.maxLength && errors.push("O campo fornecedor deve conter até 7 caracteres.");
      return errors;
    },
    codComprasErrors() {
      const errors = [];
      if (!this.$v.editedItem.forma_de_pagamento.$dirty) return errors;
      !this.$v.editedItem.forma_de_pagamento.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.forma_de_pagamento.maxLength && errors.push("O campo fornecedor deve conter até 3 caracteres.");
      return errors;
    },
    infoPagamento() {
      return "* Indica campos obrigatórios";
    },
  },
  methods: {
    fechar: function () {
      this.editedItem.forma_de_pagamento = "";
      this.editedItem.fornecedor = "";
      this.dialog_ativo = false;
      this.$v.$reset();
      this.$emit("fechar");
    },
    executarRelatorio() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const params = {
          pedido: this.pedidoSelecionado.idpedido,
          fornecedor: this.editedItem.fornecedor,
          codCompras: this.editedItem.forma_de_pagamento,
        };

        this.fechar();

        window.open(
          $axios.defaults.baseURL +
          "/exportacao_arquivo_rms?pedido=" +
          params.pedido +
          "&fornecedor=" +
          params.fornecedor +
          "&forma_de_pagamento=" +
          params.codCompras,
          "_blank"
        );

        this.$emit("exportacao-com-sucesso")
      }
    },
  },
};
</script>
